import Smartphones from 'Articles/views/ArticleView/containers/Smartphones'
import Tablets from 'Articles/views/ArticleView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const ArticleView = getCurrentDeviceView(Smartphones, Tablets)

export default ArticleView
